import { ReactNode } from "react";

import { useTryIntent } from "./use-try-intent.ts";

export interface TryIntentProps {
    children: ReactNode;
    intentType: "button" | "form" | "demo" | "buy";
    containerId?: string;
    productKey?: string;
    edition?: string;
    onAnalyticsEventFired?: () => void;
}

export const TryIntent = (props: TryIntentProps) => {
    const { children, ...hookProps } = props;

    const { onClick, onKeyDown } = useTryIntent(hookProps);

    return (
        // This is just a wrapper that doesn't affect user interactivity. Okay to ignore this a11y rule.
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        <div
            data-testid={"try-intent-wrapper"}
            onKeyDown={onKeyDown}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export default TryIntent;
